import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-24 text-center">
      <p className="text-xs uppercase tracking-[0.3em] text-[#9E3B21] font-semibold mb-3">✦ 404</p>
      <h1 className="font-serif text-5xl font-bold">Yeh page toh ghar mein nahi hai.</h1>
      <p className="mt-4 text-[#6E675F]">The pickle you're looking for might have wandered off.</p>
      <Link to="/">
        <Button data-testid="notfound-home" className="btn-primary rounded-full mt-8 px-8 py-6">Back to home</Button>
      </Link>
    </div>
  );
}
